import { EntityConfig } from "../../..";
import { useFormType } from "../../../form/hooks/useForm";
import {PecasEntregaConfig} from "./PecasEntrega.config";


export const EntregasConfig : EntityConfig = [
    {
      id: 'id',
      label: 'Id',
      type: 'id',
      nonEditable: true
    },

    {
        id: 'realDeliveryDate',
        label: 'Data Entrega',
        type: 'date',
        filterable: true,
        existsOnCopyForm: true
    },
     {
        id: 'publicDeliveryDate',
        label: 'Data entrega (para colaboradores)',
        type: 'date',
        filterable: true
     },
    {
      id: 'productionReadyDate',
      label: 'Data fim de produção',
      type: 'date',
      filterable: true,
      existsOnCopyForm: true
    },
    {
        id: 'duration',
        label: 'Duração (h)',
        type: 'number',
        nonEditable: true
    },
 
    {
      id: 'startingDate',
      label: 'Data início Produção',
      type: 'date',
      nonEditable: true,
      filterable: true
     },
     {
        id: 'duration',
        label: 'Duração',
        type: 'text',
        nonEditable: true,
      },
     {
        id: 'percentage',
        label: 'Percentagem da obra',
        type: 'number',
        
     },
     {
      id: 'pecasParaEntrega',
      label: 'Peças para entrega',
      type: 'multiple-create',
      routable: true,
      options: {
        name: 'Peças para entrega',
        route: 'pecas-entrega',
        ref: 'pecas-entrega', 
        value: 'id',
        label: 'reference',
        subFormConfig: PecasEntregaConfig,
        nestPathGetter: (form: useFormType | undefined, i: number) => form?.state['pecasParaEntrega'][i]

      }
    }

]